import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersonExtended } from '@lib/user';
import { FormControl } from '@angular/forms';
import { marker } from '@colsen1991/ngx-translate-extract-marker';

export type DefaultApprover = PersonExtended | undefined | null;

export class PurchaseRequisitionChooseSingleApproverDialogData {
    constructor(
        public readonly possibleApprovers: PersonExtended[],
        public readonly defaultApprover: DefaultApprover,
        public readonly approverRequired: boolean
    ) {}
}

export interface IPurchaseRequisitionChooseSingleApproverDialogResult {
    selectedApprover?: PersonExtended;
    cancelled: boolean;
}

@Component({
    selector: 'purchase-requisition-choose-single-approver-dialog',
    templateUrl: './purchase-requisition-choose-single-approver-dialog.component.html',
    styleUrls: ['./purchase-requisition-choose-single-approver-dialog.component.css'],
    standalone: false
})
export class PurchaseRequisitionChooseSingleApproverDialogComponent {
    readonly data = inject<PurchaseRequisitionChooseSingleApproverDialogData>(MAT_DIALOG_DATA);
    private readonly dialogRef = inject<MatDialogRef<PurchaseRequisitionChooseSingleApproverDialogComponent>>(MatDialogRef);

    public approverCtrl: FormControl<DefaultApprover | undefined>;

    public get heading(): string {
        return this.data?.approverRequired ? marker('Freigeber wählen') : marker('Rücksprache bei Bedarf');
    }

    public get label(): string {
        return this.data?.approverRequired ? marker('Freigeber') : marker('Rücksprache bei Bedarf');
    }

    constructor() {
        const data = this.data;

        this.approverCtrl = new FormControl<DefaultApprover | undefined>(data.defaultApprover);
    }

    public close(cancelled: boolean, selectedApprover?: PersonExtended): void {
        const data: IPurchaseRequisitionChooseSingleApproverDialogResult = {
            selectedApprover,
            cancelled,
        };
        this.dialogRef.close(data);
    }
}
